// extracted by mini-css-extract-plugin
export default {"noteWrapper":"PDjaHt","upsellHelper":"yNf52s"};